import { Box, Button, Callout, Dialog, Intent, Text } from "@blasterjs/core";
import React from "react";

import { DialogBody, DialogFooter, DialogHeader } from "../components/DialogLayout";
import ReasonForChange from "../components/ReasonForChange";
import { useAppDispatch, useAppSelector } from "../hooks";
import {
  closePutOnHoldCaseDialog,
  casePutOnHold,
  setPutOnHoldCaseForm
} from "../slices/putOnHoldCaseDialog";
import { casesFetch } from "../slices/cases";

const putOnHoldCaseDialog = () => {
  const dispatch = useAppDispatch();
  const putOnHoldCaseDialog = useAppSelector(state => state.putOnHoldCaseDialog);

  const closeDialog = () => {
    dispatch(closePutOnHoldCaseDialog());
  };

  const onConfirm = () => {
    putOnHoldCaseDialog.isOpen &&
      dispatch(casePutOnHold()).then(() => {
        if (putOnHoldCaseDialog.case.data.case.id) {
          dispatch(casesFetch(putOnHoldCaseDialog.case.data.case.studyId));
        }
      });
  };

  const onChangeReasonForChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    putOnHoldCaseDialog.isOpen &&
      dispatch(
        setPutOnHoldCaseForm({
          ...putOnHoldCaseDialog.case.data,
          reasonForChange: e.target.value
        })
      );
  };

  const errorText =
    putOnHoldCaseDialog.isOpen && "errorMessage" in putOnHoldCaseDialog.case ? (
      <Box mb="2">
        <Callout intent={Intent.DANGER}>
          <Text>{putOnHoldCaseDialog.case.errorMessage}</Text>
        </Callout>
      </Box>
    ) : null;

  const confirmDisabled = !(
    putOnHoldCaseDialog.isOpen && putOnHoldCaseDialog.case.data.reasonForChange
  );
  return putOnHoldCaseDialog.isOpen ? (
    <Dialog isOpen={putOnHoldCaseDialog.isOpen} onRequestClose={closeDialog} appElementId="root">
      <DialogHeader title="Put on Hold" closeDialog={closeDialog} />
      <DialogBody>
        {errorText}
        <Box>
          <Box style={{ width: "100%" }}>
            Are you sure you want to put the following case on hold?
          </Box>
          <Box style={{ width: "100%" }}>All images in the case will also be put on hold. </Box>
          <br />
          {putOnHoldCaseDialog.case.data.case.histoProcedureId && (
            <>
              Histo Procedure ID: <b>{putOnHoldCaseDialog.case.data.case.histoProcedureId}</b>
              <br />
            </>
          )}
          {putOnHoldCaseDialog.case.data.case.procId && (
            <>
              Endo Procedure ID: <b>{putOnHoldCaseDialog.case.data.case.procId}</b>
            </>
          )}
        </Box>
        <Box style={{ marginTop: 12 }}>
          Reason for Change*
          <ReasonForChange
            rkey="archiveCase_reason"
            value={
              (putOnHoldCaseDialog.isOpen && putOnHoldCaseDialog.case.data.reasonForChange) || ""
            }
            onChange={onChangeReasonForChange}
          />
        </Box>
      </DialogBody>
      <DialogFooter>
        <Button
          onClick={onConfirm}
          disabled={confirmDisabled}
          appearance="prominent"
          intent="danger"
        >
          Confirm
        </Button>
        <Button onClick={closeDialog}>Cancel</Button>
      </DialogFooter>
    </Dialog>
  ) : null;
};

export default putOnHoldCaseDialog;
